import { borderRadius, color, fontFamily, fontSize, space } from '@core-ds/primitives';
import { string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
   border-radius: ${borderRadius.sm};
   margin: ${space[1]} 0;
   padding: 1px ${space[1]};
   line-height: 15px;
   color: ${color.gray8};
   background-color: ${color.gray4};
   transition: background-color 0.1s;
   font-family: ${fontFamily.monoSystem};
   font-weight: bold;
   font-size: ${fontSize[0]};

   :hover {
      background-color: ${color.white};
   }
`;

const LanguageButton = ({ isoCode }) => (
   <Container id="js-iso-language-dropdown-button" focusable="false">
      {isoCode}
   </Container>
);

LanguageButton.propTypes = {
   isoCode: string.isRequired,
};

export default LanguageButton;
